/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import { REACT_APP_MSAL_CLIENTID, REACT_APP_MSAL_AUTHORITY, REACT_APP_MSAL_REDIRECTURI, REACT_APP_MSAL_USER_ACCESS_PERMISSION } from "../env.js";
import logger from "$services/logger.js";
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
    auth: {
        clientId: REACT_APP_MSAL_CLIENTID,
        authority: REACT_APP_MSAL_AUTHORITY,
        redirectUri: REACT_APP_MSAL_REDIRECTURI,
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        logger.error(message);
                        return;
                    case LogLevel.Info:
                        // eslint-disable-next-line no-console
                        logger.info(message);
                        return;
                    case LogLevel.Verbose:
                        // eslint-disable-next-line no-console
                        logger.debug(message);
                        return;
                    case LogLevel.Warning:
                        logger.warn(message);
                        return;
                    default:
                        // eslint-disable-next-line no-console
                        logger.info(message);
                        return;
                }
            },
            logLevel: LogLevel.Error,
            piiLoggingEnabled: false,
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [`api://${REACT_APP_MSAL_CLIENTID}/${REACT_APP_MSAL_USER_ACCESS_PERMISSION || "access_as_user"}`],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com",
};
